import React from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'secondary' | 'ghost' | 'dark';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  as?: 'button' | 'a';
  href?: string;
  to?: string;
}
const base = 'inline-flex items-center justify-center gap-2 rounded-md px-5 py-3 text-sm font-medium tracking-wide transition-all duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow disabled:opacity-60 disabled:pointer-events-none';
const variants: Record<Variant, string> = {
  primary: 'bg-yellow text-charcoal hover:brightness-95 hover:-translate-y-0.5 shadow-[0_6px_18px_-8px_rgba(255,205,0,0.7)]',
  secondary: 'bg-transparent text-charcoal border border-charcoal/25 hover:border-charcoal/60 hover:bg-charcoal/5',
  ghost: 'bg-transparent text-charcoal hover:bg-charcoal/5',
  dark: 'bg-charcoal text-cream hover:bg-charcoal/90 hover:-translate-y-0.5'
};
export function Button({
  variant = 'primary',
  as = 'button',
  className,
  children,
  href,
  to,
  ...rest
}: ButtonProps) {
  const classes = twMerge(base, variants[variant], className);
  if (to) {
    return <Link to={to} className={classes} data-id="element-21">
        {children}
      </Link>;
  }
  if (as === 'a') {
    return <a href={href} className={classes} data-id="element-22">
        {children}
      </a>;
  }
  return <button className={classes} {...rest} data-id="element-23">
      {children}
    </button>;
}